import { m } from '@hub/messages';
import type { CommunicationPreferencesSettingsDto } from '@platform/api';

export type NotificationChannel = 'email' | 'push' | 'tv' | 'inApp';

/**
 * The channels the preference matrix currently exposes. Single source of truth: it flows into
 * `NotificationPreferenceCenter`'s `allowedChannels`, which drives the rendered columns, the form
 * state and the diff for tracking alike. Channels left out here are preserved on save rather than
 * cleared, so adding one is the only edit needed to switch it on.
 */
export const notificationChannels: readonly NotificationChannel[] = ['email', 'push'];

export const channelLabels: Record<NotificationChannel, () => string> = {
  email: m.notifications_preferences_channel_email,
  push: m.notifications_preferences_channel_push,
  tv: m.notifications_preferences_channel_tv,
  inApp: m.notifications_preferences_channel_inapp,
};

export interface CategoryMeta {
  id: keyof CommunicationPreferencesSettingsDto;
  displayName: string;
  description: string;
}

const categoryIds: ReadonlyArray<keyof CommunicationPreferencesSettingsDto> = ['infos', 'offers', 'partners', 'surveys'];

export const CATEGORIES: CategoryMeta[] = categoryIds.map((id) => ({
  id,
  get displayName() {
    return m.notifications_preferences_category_name({ category: id });
  },
  get description() {
    return m.notifications_preferences_category_description({ category: id });
  },
}));
